export interface DeliveryCompany {
  code: string;
  name: string;
  remark: string;
}

export const DELIVERY_COMPANIES: DeliveryCompany[] = [
  { code: 'K001', name: '우체국', remark: 'EPOST' },
  { code: 'K002', name: 'GS 편의점', remark: 'GSPOST' },
  { code: 'K003', name: 'CJ대한통운', remark: 'CJ_DOMESTIC' },
  { code: 'K004', name: '롯데택배', remark: 'LOTTE' },
  { code: 'K005', name: 'CU 편의점', remark: 'CUPOST' },
  { code: 'K006', name: '한진택배', remark: 'HANJIN' },
  { code: 'K007', name: '합동택배', remark: 'HDEXP' },
  { code: 'K008', name: '일양로지스', remark: 'ILYANG' },
  { code: 'K009', name: '경동택배', remark: 'KDEXP' },
  { code: 'K010', name: '건영택배', remark: 'KUNYOUNG' },
  { code: 'K011', name: '로젠택배', remark: 'LOGEN' },
  { code: 'K012', name: '기타', remark: 'OTHER' },
  { code: 'K013', name: '델레오', remark: 'DELEO' },
  { code: 'K014', name: '쿠팡', remark: 'COUPANG' },
  { code: 'K015', name: '천일택배', remark: 'CHUNILPS' },
  { code: 'K016', name: 'CWAY (Woori Express)', remark: 'CWAY' },
  { code: 'K017', name: '대신택배', remark: 'DAESIN' },
  { code: 'K018', name: 'LX 판토스', remark: 'EPANTOS' },
  { code: 'K019', name: '굿투럭', remark: 'GOODSTOLUCK' },
  { code: 'K020', name: '홈픽', remark: 'HOMEPICK' },
  { code: 'K021', name: '한서호남택배', remark: 'HONAMLOGIS' },
  { code: 'K022', name: 'LTL', remark: 'LTL' },
  { code: 'K023', name: 'SLX', remark: 'SLX' },
  { code: 'K024', name: '오늘의픽업', remark: 'TODAY_PICKUP' },
  { code: 'K025', name: '용마로지스', remark: 'YONGMA_LOGIS' },
  { code: 'K026', name: '한의사랑택배', remark: 'HANIPS' },
  { code: 'I001', name: 'YUN', remark: 'YUN' },
];

export const getDeliveryCompanyName = (code: string): string => {
  const company = DELIVERY_COMPANIES.find((c) => c.code === code);
  return company ? `${company.name} ${company.remark}` : code;
};
